/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {TwoFactorEnableModel} from "../../models/two-factor-enable-model";

export interface Enable2faPostParams {
    body?: TwoFactorEnableModel
}

export function enable2faPost(headers: HttpHeaders, http: HttpClient, rootUrl: string, params: Enable2faPostParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, enable2faPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

enable2faPost.PATH = '/api/v1/identity/enable-2fa';
